import { render, staticRenderFns } from "./CodeVerificationModal.vue?vue&type=template&id=7b10bd29&scoped=true"
import script from "./CodeVerificationModal.vue?vue&type=script&lang=js"
export * from "./CodeVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./CodeVerificationModal.vue?vue&type=style&index=0&id=7b10bd29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b10bd29",
  null
  
)

export default component.exports